import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { isValidDomainName } from './domain.validators';

export const BUSINESS_EMAIL_MAX_LENGTH = 150;

/** Rejects addresses like user@test that pass Angular's built-in email validator. */
export function businessEmailTldValidator(
  control: AbstractControl
): ValidationErrors | null {
  const raw = control.value;
  if (raw == null || String(raw).trim() === '') {
    return null;
  }

  const email = String(raw).trim();
  const atIndex = email.lastIndexOf('@');
  if (atIndex <= 0 || atIndex >= email.length - 1) {
    return null;
  }

  const domain = email.slice(atIndex + 1).trim();
  return isValidDomainName(domain) ? null : { email: true };
}

export interface BusinessEmailValidatorOptions {
  required?: boolean;
}

export function getBusinessEmailValidators(
  options: BusinessEmailValidatorOptions = {}
): ValidatorFn[] {
  const validators: ValidatorFn[] = [
    Validators.email,
    Validators.maxLength(BUSINESS_EMAIL_MAX_LENGTH),
    businessEmailTldValidator,
  ];

  if (options.required) {
    validators.unshift(Validators.required);
  }

  return validators;
}
